'use client'

// ============================================================
// <BlogCtaClient cta_key="X" />
// ============================================================
// Versao client-side do BlogCta para usar em paginas que ja
// sao 'use client'. Faz fetch do CTA no mount.
// Mesmo banco e visual do BlogCta server-side.
// ============================================================

import { useEffect, useState } from 'react'
import BlogCtaCard from './blog-cta-card'

interface DbCta {
  key: string
  badge: string | null
  title: string
  body: string
  price: string | null
  price_caption: string | null
  button_text: string
  button_url: string
  variant: 'teal' | 'slate' | 'blue' | 'amber' | 'emerald' | 'purple' | 'rose' | 'indigo'
  mockup_url: string | null
  mockup_alt: string | null
  mockup_size: 'sm' | 'md' | 'lg' | 'xl'
}

interface Props {
  cta_key: string
  variant?: DbCta['variant']
}

export default function BlogCtaClient({ cta_key, variant }: Props) {
  const [cta, setCta] = useState<DbCta | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`/api/admin/ctas?key=${encodeURIComponent(cta_key)}&active=true`)
      .then(r => r.json())
      .then(d => {
        const found = (d.ctas || []).find((c: DbCta) => c.key === cta_key)
        setCta(found || null)
      })
      .catch(() => setCta(null))
      .finally(() => setLoading(false))
  }, [cta_key])

  if (loading) {
    return (
      <div className="my-10 mx-auto max-w-3xl h-48 rounded-3xl bg-stone-100 animate-pulse" />
    )
  }

  if (!cta) return null

  return (
    <BlogCtaCard
      badge={cta.badge || undefined}
      title={cta.title}
      description={cta.body}
      price={cta.price || undefined}
      priceCaption={cta.price_caption || undefined}
      buttonText={cta.button_text}
      href={cta.button_url}
      mockupSrc={cta.mockup_url || undefined}
      mockupAlt={cta.mockup_alt || undefined}
      mockupSize={cta.mockup_size === 'xl' ? 'lg' : cta.mockup_size}
      variant={variant || cta.variant}
    />
  )
}
